import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import TrainingDetailsModule from "../components/training-details-module/training-details-module";
import StickyCta from '../components/sticky-cta/sticky-cta';

export default function TrainingDetails() {
  const location = useLocation()

  useEffect(() => {
  window.scrollTo(0, 0)
}, [])

  return (  
    <div className="ae-training-detail-page ae-page-container">
      <div>
        <h1>{location.state.title}</h1>
        <TrainingDetailsModule training={location.state} />
      </div>
      <StickyCta training={location.state}/>
    </div>
  );
}